import { render, staticRenderFns } from "./CreatePropertyModal.vue?vue&type=template&id=065bffae&"
import script from "./CreatePropertyModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePropertyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports